import { render } from "./AccountShortDescription.vue?vue&type=template&id=0d8ab954&ts=true"
import script from "./AccountShortDescription.vue?vue&type=script&lang=ts"
export * from "./AccountShortDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__